'use client';

import { Check, Warning, WarningOctagon, Info } from "../../../../react-icons.js";
const getDisabledStatusIcon = (variant) => {
  if (variant === "positive") return Check;
  if (variant === "warning") return Warning;
  if (variant === "destructive") return WarningOctagon;
  return Info;
};
export {
  getDisabledStatusIcon
};
